export const tableConstants = () => {
  let formattedData = [
    {
      title: 'SNo',
      render: (rowData, idx) => {
        return <span>{idx + 1}</span>;
      },
    },
    {
      title: 'RollNo',
      render: rowData => {
        return <span>{rowData.roll_no}</span>;
      },
    },
    {
      title: 'IDNumber',
      render: rowData => {
        return <span>{rowData.id_number}</span>;
      },
    },
    {
      title: 'Name',
      render: rowData => {
        return <span>{rowData.first_name + " " + rowData.last_name}</span>;
      },
    },
     {
      title: 'Total_Present',
      render: rowData => {
        return <span style={{color:"var(--color-success-text)"}}>{rowData.total_present}</span>;
      },
    },
     {
      title: 'Total_Absent',
      render: rowData => {
        return <span style={{color:"var(--color-danger-text)"}}>{rowData.total_absent}</span>;
      },
    },
     {
      title: 'Total_Leave',
      render: rowData => {
        return <span style={{color:"var(--color-warning-text)"}}>{rowData.total_leave}</span>;
      },
    },
     {
      title: 'Total_Days',
      render: rowData => {
        return <span>{rowData.total_days}</span>;
      },
    },
     {
      title: 'Percentage',
      render: rowData => {
        return <span>{rowData.attendance_percentage} %</span>;
      },
    },
  ];

  return formattedData;
};
